import { PAGES } from "@dune/types";
import { BuilderToSubmissionFormData } from "@dune/types";
import { useEffect } from "react";
import { FormProvider } from "react-hook-form";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useAddBuilderParticipant } from "../../../../api/mutations/constructionSiteSubmission.mutations";
import { BuilderToSubmissionForm } from "../../../../component/constructionSites/submission/participants/BuilderToSubmissionForm";
import PageLayoutWithTabs from "../../../../component/layout/PageLayoutWithTabs";
import { useEntityPanelSync } from "../../../../hooks/useEntityPanelSync";
import { useBuilderToSubmissionForm } from "../../../../hooks/useParticipantToSubmissionForm";

export const AddBuilderToSubmissionPage = () => {
	const navigate = useNavigate();
	const { constructionSiteId } = useParams<{ constructionSiteId: string }>();
	const [searchParams] = useSearchParams();
	const returnUrl = searchParams.get("returnUrl");

	const addBuilderMutation = useAddBuilderParticipant(
		constructionSiteId ? Number(constructionSiteId) : 0,
	);

	const onSubmit = (data: BuilderToSubmissionFormData) => {
		addBuilderMutation.mutate(data, {
			onSuccess: () => {
				if (constructionSiteId) {
					if (returnUrl) {
						navigate(returnUrl);
					} else {
						navigate(
							PAGES.PROJECTS.submission.withParams(constructionSiteId, 4),
						);
					}
				}
			},
		});
	};

	const onCancel = () => {
		if (constructionSiteId) {
			if (returnUrl) {
				navigate(returnUrl);
			} else {
				navigate(PAGES.PROJECTS.submission.withParams(constructionSiteId, 4));
			}
		}
	};

	const { form, handleSubmit } = useBuilderToSubmissionForm({
		mode: "add",
		onSubmit,
	});

	useEntityPanelSync({
		entityType: "CONSTRUCTION_SITE",
		entityId: constructionSiteId ? Number(constructionSiteId) : 0,
	});

	useEffect(() => {
		if (!constructionSiteId) {
			navigate(PAGES.PROJECTS.index);
		}
	}, [constructionSiteId, navigate]);

	if (!constructionSiteId) {
		return null;
	}

	return (
		<PageLayoutWithTabs title="Ajouter un réalisateur">
			<FormProvider {...form}>
				<form onSubmit={handleSubmit}>
					<BuilderToSubmissionForm
						constructionSiteId={Number(constructionSiteId)}
						onSubmit={handleSubmit}
						onCancel={onCancel}
						isSubmitting={addBuilderMutation.isPending}
					/>
				</form>
			</FormProvider>
		</PageLayoutWithTabs>
	);
};
